import { render, staticRenderFns } from "./emailNotificationIndex.vue?vue&type=template&id=e406ca20"
import script from "./emailNotificationIndex.vue?vue&type=script&lang=js"
export * from "./emailNotificationIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports